import $ from 'jquery';
import 'slick-carousel';
import { programMovieSlickOptions } from './slick_config.js';

function initializeProgramMovieSlides() {
  const slidesList = document.querySelectorAll('.js_programMovieSlides');
  if (!slidesList.length) return;

  slidesList.forEach((slides) => {
    const programBlock = slides.closest('.program');
    if (!programBlock) return;

    const prevArrow = programBlock.querySelector('.program__arrow--prev');
    const nextArrow = programBlock.querySelector('.program__arrow--next');
    if (!prevArrow || !nextArrow) return;

    const options = {
      ...programMovieSlickOptions,
      prevArrow: $(prevArrow),
      nextArrow: $(nextArrow),
    };
    $(slides).slick(options);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeProgramMovieSlides();
});

function refreshProgramMovieLayout() {
  const slidesList = document.querySelectorAll('.js_programMovieSlides');
  slidesList.forEach((slides) => {
    if (!slides.classList.contains('slick-initialized')) return;
    $(slides).slick('setPosition');
  });
}

window.addEventListener('load', refreshProgramMovieLayout);

let resizeTimer = null;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(refreshProgramMovieLayout, 200);
});
